import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  Button,
  SelectField,
  TextField,
  ExpansionList,
  ExpansionPanel,
} from "react-md";
import "../styles/createPlan.css";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/assignServiceToPlan.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import EventService from "../../../../../service/event/EventService";
import PlansUtils from "../services/PlansUtils";
import { Checkbox } from "@material-ui/core";
import RangeSlider from "../services/RangeSlider";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import AssignedPlansUtil from "../services/AssignedPlansUtils";
import CreateServiceUtil from "../../service-module/services/CreateServiceUtil";
import ServiceDashboardUtils from "../../service-module/services/ServiceDashboardUtils";
import AssignServiceProviderUtil from "../../service-module/services/AssignServiceProviderUtil";
import ExpandableTableAssignedServiceProviders from "../helper/ExpandableTableAssignedServiceProviders";
import ExpandableTableAssignedChildServices from "../../service-module/helper/expandableTableAssignedChildServices";
import { Modal } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import CloseIcon from "react-md-icon/dist/RoundClose";

export const AssignServiceToPlan = (props) => {
  const [planData, setPlanData] = useState({});
  const [formData, setFormData] = useState({
    isContinueClicked: false,
  });
  const [assignServiceToPlanModesData, setAssignServiceToPlanModesData] =
    useState({});
  const [
    extraAssignServiceToPlanModesData,
    setExtraAssignServiceToPlanModesData,
  ] = useState({});
  const [serviceTypeData, setServiceTypeData] = useState({});

  const [mode, setMode] = useState(1);
  const [accountDetails, setAccountDetails] = useState(null);
  const [familyRelationsArr, setFamilyRelationsArr] = useState([
    {
      code: 0,
      value: "Self",
      gender: 0,
    },
  ]);
  const [allRelations, setAllRelations] = useState([0]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [expandableTables, setExpandableTables] = useState(<></>);
  const [assignedServiceProviderPageNums, setAssignedServiceProviderPageNums] =
    useState({});

  const [assignedChildServicesResponse, setAssignedChildServicesResponse] =
    useState(null);
  const [allProvidersOfChildService, setAllProvidersOfChildService] =
    useState(null);
  const [
    expandableTableAssignedChildServicesPageNum,
    setExpandableTableAssignedChildServicesPageNum,
  ] = useState(1);
  const [
    expandableTableAssignedChildServicesPageSize,
    setExpandableTableAssignedChildServicesPageSize,
  ] = useState(30);
  const [
    expandableTableAssignedChildServicesTotalCount,
    setExpandableTableAssignedChildServicesTotalCount,
  ] = useState(1);

  const [pageSize, setPageSize] = useState(30);
  const [totalCount, setTotalCount] = useState(10);
  const [assignedServiceProviders, setAssignedServiceProviders] = useState([]);
  const [
    assignedServiceProvidersForFilters,
    setAssignedServiceProvidersForFilters,
  ] = useState([]);

  const [componentMounted, setComponentMounted] = useState(false);
  const [validModes, setValidModes] = useState([]);

  const plansUtils = new PlansUtils();
  const assignedPlansUtils = new AssignedPlansUtil();
  const createServiceUtil = new CreateServiceUtil();
  const assignServiceProviderUtil = new AssignServiceProviderUtil();
  const serviceDashboardUtils = new ServiceDashboardUtils();

  useEffect(() => {
    setComponentMounted(true);
    if (props?.data?.mode == "view" || props?.data?.mode == "update") {
      setFormData({
        isContinueClicked: true,
      });
      fetchAssignedServiceToPlan(props?.data?.planId, props?.data?.serviceId);
      fetchAssignedServiceProvidersByFilter(
        props?.data?.planId,
        props?.data?.serviceId,
        "",
        0,
        {},
        true,
        0,
      );
    }
    getPlanByFilter(props?.data?.planId);
    getFamilyRelations();
    getServiceTypes("true");
  }, []);

  useEffect(() => {
    if (planData?.accountCode != null) {
      getAccountByAccountCode(planData?.accountCode);
    }
  }, [planData]);

  useEffect(() => {
    // return Object.entries(data).map(([key, value]) => ({
    //   modeName: key,
    //   ...value,
    // }));

    if (componentMounted) {
      Object.entries(assignedServiceProviders).forEach(([key, value]) => {
        setExpandableTables((prev) => ({
          ...prev,
          [key]: (
            <ExpandableTableAssignedServiceProviders
              {...{
                data: {
                  accountId: props?.data?.accountId,
                  planId: props?.data?.planId,
                  serviceMode: key,
                  serviceId: props?.data?.serviceId,
                  assignedServiceProviders: value?.providers,
                  assignedServiceProvidersForFilters:
                    assignedServiceProvidersForFilters?.providers,
                },
                setView: props?.setView,
                goToPrevPage: navigateToPrevPage,
                goToNextPage: navigateToNextPage,
                fetchAssignedServiceProvidersByFilter:
                  fetchAssignedServiceProvidersByFilterHelper,
                setAssignedServiceProviderPageNums:
                  setAssignedServiceProviderPageNums,
                totalCount: value?.totalCount,
                pageNum: assignedServiceProviderPageNums?.[key],
                pageSize: pageSize,
              }}
            />
          ),
        }));
      });
    }
  }, [assignedServiceProviders]);

  // useEffect(() => {

  //   if (props?.data?.editMode == "service-providers") {
  //     fetchAssignedServiceProvidersByFilterHelper(
  //       props?.data?.planId,
  //       props?.data?.serviceId,
  //       modeName
  //     );
  //   }

  // }, [assignedServiceProviderPageNums]);

  const fetchAssignedChildServicesByFilter = (
    groupServiceId,
    pageNum,
    pageSize,
    filtersObj,
    includeProviderDetails,
    isActive = true,
    isConfirmCheck = false,
  ) => {
    const onResponse = (res) => {
      console.log("ni- fetchAssignedChildServicesByFilter res=", res);
      setAssignedChildServicesResponse(res);
      setExpandableTableAssignedChildServicesTotalCount(res?.totalCount);
      if (isConfirmCheck) {
        if (!res?.services || res.services.length === 0) {
          EventService.emit("showError", {
            message:
              "This group service has no active child services, so it cannot be assigned to the plan. Please add active child services to the group first.",
          });
          setFormData((prev) => ({ ...prev, isContinueClicked: false }));
        } else {
          setFormData((prev) => ({ ...prev, isContinueClicked: true }));
        }
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching assigned child services: ${err?.message}`,
      });
    };
    serviceDashboardUtils.fetchAssignedChildServicesByFilter(
      {
        pageNum: pageNum,
        pageSize: pageSize,
        groupServiceId: groupServiceId,
        isActive: isActive,
        ...(filtersObj ?? {}),
        includeProviderDetails: includeProviderDetails ?? false,
      },
      onResponse,
      onError,
    );
  };

  const navigateToNextPage = (modeName, filterObj) => {
    const totalCount = assignedServiceProviders?.[modeName]?.totalCount ?? 0;
    if (assignedServiceProviderPageNums?.[modeName] * pageSize < totalCount) {
      if (props?.data?.editMode == "service-providers") {
        fetchAssignedServiceProvidersByFilterHelper(
          props?.data?.planId,
          props?.data?.serviceId,
          modeName,
          assignedServiceProviderPageNums?.[modeName] + 1,
          filterObj,
        );
      }
      setAssignedServiceProviderPageNums((prevPageNums) => ({
        ...prevPageNums,
        [modeName]: prevPageNums?.[modeName] + 1,
      }));
    }
  };

  const navigateToPrevPage = (modeName, filterObj) => {
    if (assignedServiceProviderPageNums?.[modeName] > 1) {
      if (props?.data?.editMode == "service-providers") {
        fetchAssignedServiceProvidersByFilterHelper(
          props?.data?.planId,
          props?.data?.serviceId,
          modeName,
          assignedServiceProviderPageNums?.[modeName] - 1,
          filterObj,
        );
      }
      setAssignedServiceProviderPageNums((prevPageNums) => ({
        ...prevPageNums,
        [modeName]: prevPageNums?.[modeName] - 1,
      }));
    }
  };

  const EMPTY_PLAN_SERVCE_MODE_RULE = {
    relations: [],
    planAgeRule: {
      isApplicable: false,
      fromAge: 18,
      toAge: 60,
    },
    planGenderRule: {
      isApplicable: false,
      gender: 0,
    },
    planTimeRule: {
      isServiceAvailLimited: true,
      maxServiceAvailCount: 0,
      isTimeRuleApplicable: false,
      timeRuleApplicableDays: 0,
      isInclusiveOfAllRelations: false,
    },
    price: 0.0,
    // Sponsored value: a deduction off the mode's discounted price, entered as a percentage
    // (unit 1) or a fixed amount (unit 2). Must be enabled for the rule to apply. Mirrors the
    // wallet copay { enabled, value, unit } shape.
    customSponsorshipDetails: {
      enabled: false,
      value: 0,
      unit: 2,
    },
  };

  const removeKey = (obj, keyToRemove) => {
    const newObj = { ...obj }; // Create a shallow copy to avoid mutating the original object
    delete newObj[keyToRemove]; // Delete the key
    return newObj;
  };

  const fetchAssignedServiceProvidersByFilterHelper = (
    planId,
    serviceId,
    modeName,
    pageNumValue = null,
    filterObj = {},
  ) => {
    if (!planId || !serviceId || !modeName) {
      return;
    }
    // setPageNum(1);
    // setFilterObj(filterObj);
    // if (modesData) {
    //   modesData.forEach((e) => {

    //     if (e?.modeName) {
    fetchAssignedServiceProvidersByFilter(
      planId,
      serviceId,
      modeName,
      pageNumValue,
      filterObj ?? {},
    );

    //   }
    // });
    // }
  };

  const fetchAssignedServiceProvidersByFilter = (
    planId,
    serviceId,
    modeName,
    pageNumValue = null,
    filterObj = {},
    fetchAllForFilters = false,
    pageSizee = null,
  ) => {
    const onResponse = (res) => {
      console.log("ni- fetchAssignedServiceProvidersByFilter res=", res);
      // if (res?.services?.[0]) {
      if (props?.data?.editMode == "service-providers") {
        if (fetchAllForFilters) {
          setAssignedServiceProvidersForFilters(res);
        } else {
          setAssignedServiceProviders((prev) => ({
            ...prev,
            [modeName]: {
              providers: res?.providers ?? [],
              totalCount: res?.totalCount,
            },
          }));
        }
      }
      // } else {
      //   EventService.emit("showError", {
      //     message: `No service matched with the provided details.`,
      //   });
      // }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetchAssignedServiceProvidersByFilter: ${err?.message}`,
      });
    };
    assignedPlansUtils.fetchAssignedServiceProvidersByFilter(
      {
        pageNum: pageNumValue ?? assignedServiceProviderPageNums?.[modeName],
        pageSize: pageSizee ?? pageSize,
        serviceIds: [serviceId],
        planId: planId,
        mode: modeName,
        ...filterObj,
      },
      onResponse,
      onError,
    );
  };

  const updateAssignServiceToPlanModesDataField = (
    parentKey,
    fieldKey,
    newValue,
  ) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setAssignServiceToPlanModesData((prevData) => ({
      ...prevData,
      [parentKey]: {
        ...prevData[parentKey],
        [fieldKey]: newValue,
      },
    }));
    if (fieldKey === "isEnabled" && newValue === false) {
      const newObj = removeKey(assignServiceToPlanModesData, parentKey);
      setAssignServiceToPlanModesData(newObj);
    }
  };

  const updateExtraAssignServiceToPlanModesDataField = (
    parentKey,
    fieldKey,
    newValue,
  ) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setExtraAssignServiceToPlanModesData((prevData) => ({
      ...prevData,
      [parentKey]: {
        ...prevData[parentKey],
        [fieldKey]: newValue,
      },
    }));
  };

  const exitPage = () => {
    setPlanData({});
    setFormData({
      isContinueClicked: false,
    });
    setAssignServiceToPlanModesData({});
    setExtraAssignServiceToPlanModesData({});
    setServiceTypeData({});
    props.setView(3, {
      mode: "assign-service",
      accountId: props?.data?.accountId,
      planId: props?.data?.planId,
    });
    setValidModes([]);
  };

  const getServiceTypes = (status) => {
    const onResponse = (res) => {
      console.log("ni- service types res=", res);
      setServiceTypes(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching service types: ${err?.message}`,
      });
    };
    createServiceUtil.getServiceType(status, onResponse, onError);
  };

  const fetchAssignedServiceToPlan = (planId, serviceId) => {
    const onResponse = (res) => {
      console.log("ni- fetchAssignedServiceToPlan types res=", res);
      // setServiceTypes(res);
      if (res?.serviceId && res?.serviceTypeId) {
        getServiceDataByFilter(res?.serviceId, res?.serviceTypeId, null);
        getServiceTypeDataById(res?.serviceTypeId);

        if (props?.data?.mode == "update") {
          getValidModes(res?.serviceId);
        }
      }
      // fetching assigned service providers
      // if (props?.data?.editMode == "service-providers") {
      //   fetchAssignedServiceProvidersByFilterHelper(
      //     planId,
      //     serviceId,
      //     res?.serviceModeDetails
      //   );
      // }

      setFormData((prev) => ({
        ...prev,
        groupServiceStatus: res?.groupServiceStatus,
      }));

      if (res?.serviceModeDetails) {
        setAssignServiceToPlanModesData((prevData) =>
          reverseConvertServiceModesData(res?.serviceModeDetails),
        );
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching AssignedServiceToPlan : ${err?.message}`,
      });
    };
    assignedPlansUtils.fetchAssignedServiceToPlan(
      planId,
      serviceId,
      onResponse,
      onError,
    );
  };

  const getAccountByAccountCode = (code) => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      accountCode: code,
    };
    const onResponse = (res) => {
      setAccountDetails(res.accounts[0]);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getAccountsByFilter(body, onResponse, onError);
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  const getValidModes = (id) => {
    let modes1 = [];
    const body = {
      pageNum: 0,
      pageSize: 0,
      serviceIds: [id],
    };
    let onResponse = (res) => {
      if (
        res != null &&
        res.resultCount > 0 &&
        res.assignedServiceProviders.length > 0
      ) {
        res.assignedServiceProviders.forEach((e) => {
          if (
            e.isActive &&
            e.serviceModes != null &&
            e.serviceModes.length > 0
          ) {
            e.serviceModes.forEach((m) => {
              if (m.modeStatus && m.enabled) {
                modes1.push(m.mode);
              }
            });
          }
        });
      }

      setValidModes([...new Set(modes1)]);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching valid modes: ${err?.message}`,
      });
    };

    assignServiceProviderUtil.getAssignedServiceProvidersByFilter(
      body,
      onResponse,
      onError,
    );
  };
  const getServiceTypeDataById = (id) => {
    let onResponse = (res) => {
      console.log("ni- got servType res for id=", res);
      setServiceTypeData(res);
      if (props?.data?.mode == "assign") {
        getValidModes(formData?.service.id);
      }
      // intializing pagenums for assigned service providers table
      if (res?.modes) {
        res.modes.forEach((e) => {
          setAssignedServiceProviderPageNums((prev) => ({ ...prev, [e]: 1 }));
        });
      }
      // setAssignedServiceProviderData({service: assignedServiceProviderData?.service, serviceProvider: res});
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service provider details: ${err?.message}`,
      });
    };
    assignServiceProviderUtil.getServiceTypeById(id, onResponse, onError);
  };

  const getServiceDataByFilter = (idNum, serviceTypeId, serviceCode) => {
    const onResponse = (res) => {
      console.log("ni- getServiceDataByFilter res=", res);
      if (res?.services?.[0]) {
        setFormData((prev) => ({ ...prev, service: res?.services?.[0] }));
      } else {
        EventService.emit("showError", {
          message: `No service matched with the provided details.`,
        });
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching service details: ${err?.message}`,
      });
    };
    serviceDashboardUtils.getServicesByFilter(
      idNum
        ? {
            pageNum: 1,
            pageSize: 1,
            status: "active",
            Ids: [stringToInt(idNum)],
            serviceTypeIds: [serviceTypeId],
          }
        : {
            pageNum: 1,
            pageSize: 1,
            status: "active",
            nameMatch: [serviceCode?.toString()],
            serviceTypeIds: [serviceTypeId],
          },
      onResponse,
      onError,
    );
  };

  const getPlanByFilter = (planId) => {
    const onResponse = (res) => {
      console.log("ni- got res for getPlansByFilter: ", res);
      if (res?.plans?.[0]) {
        setPlanData((prevData) => res?.plans?.[0] ?? {});
      } else {
        EventService.emit("showError", {
          message: `No plan found with planId - (${planId.toString()})`,
        });
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching plan details: ${err?.message}`,
      });
    };
    assignedPlansUtils.getAssignedPlansByFilter(
      {
        pageNum: 1,
        pageSize: 1,
        planIds: [planId],
      },
      onResponse,
      onError,
    );
  };

  const assignServiceToPlan = (body) => {
    const onResponse = (res) => {
      if (props?.data?.mode == "assign") {
        console.log("ni- got res for assignServiceToPlan: ", res);
        EventService.emit("showError", {
          message: `Successfully assigned the service to the plan`,
        });
      } else if (props?.data?.mode == "update") {
        console.log("ni- got res for updateAssignedServiceToPlan: ", res);
        EventService.emit("showError", {
          message: `Successfully updated the service assignment to plan`,
        });
      }
      exitPage();
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in assigning service to plan: ${err?.message}`,
      });
    };

    if (props?.data?.mode == "assign") {
      assignedPlansUtils.assignServiceToPlan(body, onResponse, onError);
    } else if (props?.data?.mode == "update") {
      assignedPlansUtils.updateAssignedServiceToPlan(body, onResponse, onError);
    }
  };

  const updateFormDataField = (parentKey, fieldKey, newValue) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setFormData((prevData) => ({
      ...prevData,
      [parentKey]: {
        ...prevData[parentKey],
        [fieldKey]: newValue,
      },
    }));
  };

  const convertServiceModesData = (data) => {
    if (!data || Object.keys(data).length === 0) {
      return []; // Return an empty array if data is null, undefined, or empty
    }

    return Object.entries(data).map(([key, value]) => ({
      modeName: key,
      ...value,
    }));
  };

  const prepareBodyForServiceAssignment = () => {
    return {
      planId: planData?.id,
      planIdNum: planData?.planIdNum,
      serviceId: formData?.service?.id,
      serviceTypeId: formData?.service?.serviceTypeId,
      serviceSubtypeId: formData?.service?.serviceSubtypeId,
      serviceModeDetails:
        formData?.service?.serviceCategory === 1
          ? null
          : convertServiceModesData(assignServiceToPlanModesData),
      serviceCategory: formData?.service?.serviceCategory,
      isSponsoredOnly: formData?.isSponsoredOnly ?? false,
      groupServiceStatus: formData?.groupServiceStatus,
    };
  };

  const getFamilyRelations = () => {
    const onResponse = (res) => {
      let allRelations = res?.map((e) => {
        return e.code;
      });
      setAllRelations((prev) => [...prev, ...allRelations]);
      setFamilyRelationsArr((prev) => [...prev, ...res]);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching family relations: ${err?.message}`,
      });
    };
    plansUtils.getFamilyRelations(onResponse, onError);
  };

  const isServiceValidForConfirm = () => {
    let errorOccurred = false;
    if (formData?.service) {
      const serviceRequiredFields = [
        "serviceTypeId",
        "id",
        "name",
        // "serviceSubtypeName",
        "serviceName",
      ];
      serviceRequiredFields.forEach((e) => {
        if (errorOccurred) return;
        if (formData?.service?.[e]) {
        } else {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `${e} is required in service details`,
          });
        }
      });
    } else {
      EventService.emit("showError", {
        message: "Please enter service details",
      });
      errorOccurred = false;
      return false;
    }

    if (errorOccurred) {
      return false;
    }

    return true;
  };

  const reverseConvertServiceModesData = (array) => {
    if (!Array.isArray(array) || array.length === 0) {
      return {}; // Return an empty object if input is null, undefined, or empty
    }

    const ans = array.reduce((acc, item) => {
      const { modeName, ...rest } = item; // Extract mode as key, rest as value
      acc[modeName] = rest;
      return acc;
    }, {});

    return ans;
  };

  let isFormValid = (formData, ModesData) => {
    if (!props?.data?.planId) {
      EventService.emit("showError", {
        message: `Invalid plan ID`,
      });
      return false;
    }

    if (
      formData?.service?.serviceTypeId == null ||
      formData?.service?.serviceTypeId?.toString()?.trim() === ""
    ) {
      EventService.emit("showError", {
        message: `Service type id num is required in service details.`,
      });
      return false;
    }

    if (
      formData?.service?.serviceSubtypeId == null ||
      formData?.service?.serviceSubtypeId?.toString()?.trim() === ""
    ) {
      EventService.emit("showError", {
        message: `Service subType id num is required in service details.`,
      });
      return false;
    }

    // return true(do not check below validations) if service category is 1 (i.e group service)
    if (formData?.service?.serviceCategory === 1) {
      if (
        formData?.groupServiceStatus == null ||
        formData?.groupServiceStatus?.toString()?.trim() === ""
      ) {
        EventService.emit("showError", {
          message: `Group service status is a required field.`,
        });
        return false;
      }
      return true;
    }

    // should have at least one serviceMode
    if (ModesData == null || Object.entries(ModesData)?.length === 0) {
      EventService.emit("showError", {
        message: `At least one service mode is required.`,
      });
      return false;
    }

    // add required fields as validation targets to validate them.
    let validationTargets = { service: ["serviceTypeId", "id", "name"] };

    const modesRequiredFields = ["maxPrice", "discountedPrice", "isModeActive"];
    const planServiceModeRulesRequiredFields = ["maxServiceAvailCount"];

    let errorOccurred = false;
    Object.entries(validationTargets).forEach(([key, values]) => {
      values.forEach((val) => {
        if (errorOccurred) return;
        const value = formData?.[key]?.[val];
        console.log(`  - ${val} is required in ${key} details: ${value}`);
        if (value == null || value?.toString()?.trim() === "") {
          EventService.emit("showError", {
            message: `${val} is required in ${key} details.`,
          });
          errorOccurred = true;
        }
      });
      // }
    });

    if (errorOccurred) {
      return false;
    }

    errorOccurred = false;
    Object.entries(ModesData).forEach(([key, values]) => {
      modesRequiredFields.forEach((e) => {
        if (errorOccurred) return;
        if (ModesData?.[key]?.isEnabled) {
          const value = ModesData?.[key]?.[e];
          // console.log(`  - ${val} is required in ${key} details: ${value}`);
          if (value == null || value?.toString()?.trim() === "") {
            EventService.emit("showError", {
              message: `${e} is required in ${key} mode details.`,
            });
            errorOccurred = true;
          }
        }
      });
      if (errorOccurred) {
        return false;
      }

      errorOccurred = false;
      if (
        ModesData?.[key]?.isAdvanceRuleApplicable &&
        ModesData?.[key]?.planServiceModeRules
      ) {
        ModesData[key].planServiceModeRules.forEach((ele, i) => {
          if (errorOccurred) return;
          const rels = ele?.relations ?? [];
          if (rels.length <= 0) {
            EventService.emit("showError", {
              message: `Please select at least one relation in sponsorship rule no. - ${
                i + 1
              } for the mode - ${key}`,
            });
            errorOccurred = true;
            return;
          }
          const valu = ele?.planTimeRule?.maxServiceAvailCount;
          if (
            ele?.planTimeRule?.isServiceAvailLimited &&
            (valu == null ||
              valu?.toString()?.trim() === "" ||
              valu?.toString()?.trim() == "0")
          ) {
            EventService.emit("showError", {
              message: `Define sponsorship limit in the sponsorship rule no. - ${
                i + 1
              } for the mode - ${key}`,
            });
            errorOccurred = true;
            return;
          }
          // Custom sponsorship is optional: when not enabled the service is fully sponsored
          // (the patient pays 0). Only validate the value when it is enabled.
          if (ele?.customSponsorshipDetails?.enabled) {
            const cs = ele.customSponsorshipDetails;
            const dp = ModesData[key]?.discountedPrice ?? 0;
            if (cs?.value == null) {
              EventService.emit("showError", {
                message: `Custom sponsorship value is required in the sponsorship rule no. - ${
                  i + 1
                } for the mode - ${key}`,
              });
              errorOccurred = true;
              return;
            }
            if (cs.value < 0) {
              EventService.emit("showError", {
                message: `Custom sponsorship value cannot be negative in the sponsorship rule no. - ${
                  i + 1
                } for the mode - ${key}`,
              });
              errorOccurred = true;
              return;
            }
            if (cs.unit === 1 && cs.value > 100) {
              EventService.emit("showError", {
                message: `Custom sponsorship percentage cannot exceed 100 in the sponsorship rule no. - ${
                  i + 1
                } for the mode - ${key}`,
              });
              errorOccurred = true;
              return;
            }
            if (cs.unit === 2 && cs.value > dp) {
              EventService.emit("showError", {
                message: `Custom sponsorship amount cannot be more than discounted price in the sponsorship rule no. - ${
                  i + 1
                } for the mode - ${key}`,
              });
              errorOccurred = true;
              return;
            }
          }
        });
      }
    });

    if (errorOccurred) {
      return false;
    }

    return true;
  };

  const getAdvanceRuleSection = (
    rule,
    setAdvanceRule,
    idx,
    removeRule,
    alreadySelectedRelations,
    planServiceModeRules,
    discountedPrice,
  ) => {
    // prepare alreadySelectedRelations (by removing relations selected for current rule idx)
    let alreadySelectedRelationsExceptCurrent = [];
    alreadySelectedRelations.forEach((e, i) => {
      if (i != idx) {
        alreadySelectedRelationsExceptCurrent = [
          ...alreadySelectedRelationsExceptCurrent,
          ...e,
        ];
      }
    });

    return (
      <div className="mp-astp-rules-outer-div">
        <div className="mp-astp-rules-family-member-div">
          <div>
            Applicable for &nbsp; &nbsp;
            <Checkbox
              style={{ margin: 0, padding: 0 }}
              checked={
                (rule?.relations ?? []).length >=
                familyRelationsArr.length -
                  alreadySelectedRelationsExceptCurrent.length
              }
              color="secondary"
              disabled={props?.data?.mode == "view"}
              onChange={(e) => {
                console.log("clicked");
                if (e.target.checked) {
                  let allRelCodes = (familyRelationsArr ?? []).map(
                    (obj) => obj.code,
                  );
                  let removedCommonRelCode = [];
                  allRelCodes.forEach((e) => {
                    if (!alreadySelectedRelationsExceptCurrent.includes(e)) {
                      removedCommonRelCode.push(e);
                    }
                  });
                  rule.relations = removedCommonRelCode;
                } else {
                  rule.relations = [];
                }
                setAdvanceRule(rule);
              }}
            />
            &nbsp; All
          </div>
          {Boolean(
            planServiceModeRules.length > 1 && props?.data?.mode != "view",
          ) && (
            <div
              className="mp-advance-rule-close-fonticon-astp"
              onClick={(e) => removeRule(idx)}
            >
              <FontIcon>close</FontIcon>
            </div>
          )}
        </div>

        <div className="mp-assign-service-to-plan-family-relations-bubbles-div">
          {familyRelationsArr &&
            familyRelationsArr?.map((rel) => {
              if (alreadySelectedRelationsExceptCurrent.includes(rel?.code)) {
                return <></>;
              }
              return (
                <div
                  className={
                    (rule?.relations ?? []).includes(rel?.code)
                      ? "mp-plan-box-selected"
                      : "mp-plan-box-unselected"
                  }
                  onClick={() => {
                    if (props?.data?.mode == "view") {
                      return;
                    }
                    if ((rule?.relations ?? []).includes(rel?.code)) {
                      rule.relations = (rule?.relations ?? []).filter(
                        (item) => item !== rel?.code,
                      );
                      setAdvanceRule(rule);
                    } else {
                      rule.relations = [...(rule?.relations ?? []), rel?.code];
                      setAdvanceRule(rule);
                    }
                  }}
                >
                  <div className="mp-plan-font">
                    {rel.code == 6
                      ? "Daughter < 18"
                      : rel.code == 7
                        ? "Daughter > 18"
                        : rel.code == 8
                          ? "Son < 18"
                          : rel.code == 9
                            ? "Son > 18"
                            : rel.code == 6
                              ? "Daughter < 18"
                              : rel.value}
                  </div>
                </div>
              );
            })}
        </div>
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={rule?.planAgeRule?.isApplicable ?? false}
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    rule.planAgeRule.isApplicable = e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Age Rule Applicable (From ${rule?.planAgeRule?.fromAge} to ${rule?.planAgeRule?.toAge})`}
              </div>
              {/* <div> */}
              <RangeSlider
                min={rule.planAgeRule.fromAge}
                max={rule.planAgeRule.toAge}
                rangeMin={0}
                rangeMax={150}
                disabled={
                  !(rule?.planAgeRule?.isApplicable ?? false) ||
                  props?.data?.mode == "view"
                }
                setAge={(min, max) => {
                  rule.planAgeRule.fromAge = min;
                  rule.planAgeRule.toAge = max;
                  setAdvanceRule(rule);
                }}
              />
              {/* </div> */}
            </div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={rule?.planGenderRule?.isApplicable ?? false}
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    rule.planGenderRule.isApplicable = e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Gender rule applicable`}
              </div>
              {/* <div> */}
              <SelectField
                menuItems={[
                  {
                    label: "Female",
                    value: 1,
                  },
                  {
                    label: "Male",
                    value: 2,
                  },
                ]}
                placeholder="Select"
                fullWidth
                disabled={
                  !(rule?.planGenderRule?.isApplicable ?? false) ||
                  props?.data?.mode == "view"
                }
                onChange={(e) => {
                  rule.planGenderRule.gender = e;
                  setAdvanceRule(rule);
                }}
                value={
                  rule?.planGenderRule?.gender
                    ? (rule?.planGenderRule?.gender ?? "")
                    : ""
                }
              />
              {/* </div> */}
            </div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div
                className="mp-plan-label-v2"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={rule?.customSponsorshipDetails?.enabled ?? false}
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    if (!rule.customSponsorshipDetails) {
                      rule.customSponsorshipDetails = {
                        enabled: false,
                        value: 0,
                        unit: 2,
                      };
                    }
                    rule.customSponsorshipDetails.enabled = e.target.checked;
                    rule.customSponsorshipDetails.value = 0;
                    setAdvanceRule(rule);
                  }}
                />
                {"Custom sponsorship details"}
              </div>
              {rule?.customSponsorshipDetails?.enabled ? (
                <Row>
                  <Col xs={5} sm={5} md={5} lg={5}>
                    <SelectField
                      menuItems={[
                        { label: "Amount (₹)", value: 2 },
                        { label: "Percent (%)", value: 1 },
                      ]}
                      placeholder="Type"
                      fullWidth
                      disabled={props?.data?.mode == "view"}
                      value={rule?.customSponsorshipDetails?.unit ?? 2}
                      onChange={(e) => {
                        rule.customSponsorshipDetails.unit = e;
                        rule.customSponsorshipDetails.value = 0;
                        setAdvanceRule(rule);
                      }}
                    />
                  </Col>
                  <Col xs={7} sm={7} md={7} lg={7}>
                    <TextField
                      fullWidth
                      placeholder={
                        (rule?.customSponsorshipDetails?.unit ?? 2) === 1
                          ? "max 100"
                          : `max ${discountedPrice ?? 0}`
                      }
                      value={rule?.customSponsorshipDetails?.value ?? ""}
                      disabled={props?.data?.mode == "view"}
                      onChange={(e) => {
                        if (e != null && e.toString().length > 6) return;
                        const val = stringToInt(e);
                        const unit = rule?.customSponsorshipDetails?.unit ?? 2;
                        if (val != null) {
                          if (unit === 1 && val > 100) return;
                          if (unit === 2 && val > (discountedPrice ?? 0))
                            return;
                        }
                        rule.customSponsorshipDetails.value = val;
                        setAdvanceRule(rule);
                      }}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      lineDirection="left"
                    />
                  </Col>
                </Row>
              ) : null}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label-v2">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={!(rule?.planTimeRule?.isServiceAvailLimited ?? true)}
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      rule.planTimeRule.isTimeRuleApplicable = false;
                    }
                    rule.planTimeRule.isServiceAvailLimited = !e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Check mark if unlimited or define limit below`}
                <label className="account-module-label-red"> *</label>
              </div>
              {/* <div> */}
              <TextField
                fullWidth
                placeholder="Type here to define limit"
                value={
                  rule?.planTimeRule?.maxServiceAvailCount == 0
                    ? ""
                    : (rule?.planTimeRule?.maxServiceAvailCount ?? "")
                }
                disabled={
                  !(rule?.planTimeRule?.isServiceAvailLimited ?? true) ||
                  props?.data?.mode == "view"
                }
                onChange={(e) => {
                  rule.planTimeRule.maxServiceAvailCount = stringToInt(
                    e == "" ? "0" : e,
                  );
                  setAdvanceRule(rule);
                }}
                type="number"
                lineDirection="left"
              />
              {/* </div> */}
            </div>
          </Col>
          {/* <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={rule?.planTimeRule?.isTimeRuleApplicable ?? false}
                  color="secondary"
                  disabled={
                    !(rule?.planTimeRule?.isServiceAvailLimited ?? true) ||
                    props?.data?.mode == "view"
                  }
                  onChange={(e) => {
             
                  
                    rule.planTimeRule.isTimeRuleApplicable = e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Time period rule is applicable`}
              </div>
              <TextField
                fullWidth
                placeholder="Enter number of days"
                value={rule?.planTimeRule?.timeRuleApplicableDays ?? ""}
                disabled={
                  !(rule?.planTimeRule?.isTimeRuleApplicable ?? false) ||
                  props?.data?.mode == "view"
                }
                onChange={(e) => {
                  rule.planTimeRule.timeRuleApplicableDays = stringToInt(
                    e == "" ? "0" : e
                  );
                  setAdvanceRule(rule);
                }}
                type="number"
                lineDirection="left"
              />
            </div>
          </Col> */}
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={
                    rule?.planTimeRule?.isInclusiveOfAllRelations ?? false
                  }
                  color="secondary"
                  disabled={props?.data?.mode == "view"}
                  onChange={(e) => {
                    rule.planTimeRule.isInclusiveOfAllRelations =
                      e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Inclusive of all`}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const getAssignedServicesSection = () => {
    return (
      <div>
        <Row>
          {Boolean(formData?.service?.serviceCategory === 1) && (
            <Col xs={12} sm={3} md={3} lg={3}>
              <div className="mp-plan-create-service-field-container">
                <div className="mp-plan-label">
                  {`Group service status`}
                  <label className="account-module-label-red"> *</label>
                </div>
                <div>
                  <SelectField
                    menuItems={["Active", "Inactive"]}
                    fullWidth
                    placeholder="Select"
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        groupServiceStatus: e === "Active" ? true : false,
                      }))
                    }
                    disabled={props?.data?.mode == "view"}
                    value={
                      formData?.groupServiceStatus === true
                        ? "Active"
                        : formData?.groupServiceStatus === false
                          ? "Inactive"
                          : ""
                    }
                  />
                </div>
              </div>
            </Col>
          )}
        </Row>
        <br />

        <ExpandableTableAssignedChildServices
          assignedChildServices={assignedChildServicesResponse?.services ?? []}
          providerMap={assignedChildServicesResponse?.providerMap ?? []}
          provdersLimit={2}
          mode={"view"}
          pageNum={expandableTableAssignedChildServicesPageNum}
          pageSize={expandableTableAssignedChildServicesPageSize}
          totalCount={expandableTableAssignedChildServicesTotalCount}
          // stagedForUpdateChildServices={stagedForUpdateChildServices}
          setAllProvidersOfChildService={setAllProvidersOfChildService}
          fetchAssignedChildServicesByFilter={(filtersObj) => {
            fetchAssignedChildServicesByFilter(
              formData?.service?.id,
              expandableTableAssignedChildServicesPageNum,
              expandableTableAssignedChildServicesPageSize,
              filtersObj,
              true,
            );
          }}
          handleDeleteAssignedChildService={(service) => {}}
        />

        {Boolean(allProvidersOfChildService) && (
          <Modal open={true} onClose={() => {}} disableBackdropClick={true}>
            <div
              style={{ width: "90%", left: "45%" }}
              className="custom-modal-content scrollable-modal-full-height"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    fontSize: "24px",
                    fontWeight: 700,
                    fontFamily: "Montserrat",
                    textAlign: "center",
                  }}
                >
                  {"(" +
                    allProvidersOfChildService?.assignedChildServices?.[0]?.id +
                    ") " +
                    allProvidersOfChildService?.assignedChildServices?.[0]
                      ?.serviceName}
                </div>

                <IconButton onClick={() => setAllProvidersOfChildService(null)}>
                  <CloseIcon fontSize="large" />
                </IconButton>
              </div>

              <div style={{ height: "32px" }}></div>

              <div style={{ textAlign: "left" }}>
                <ExpandableTableAssignedChildServices
                  assignedChildServices={
                    allProvidersOfChildService?.assignedChildServices ?? []
                  }
                  providerMap={allProvidersOfChildService?.providerMap ?? []}
                  fetchAssignedChildServicesOnInit={false}
                  mode={"view"}
                  showPagination={false}
                  showSeeAll={false}
                  pageNum={expandableTableAssignedChildServicesPageNum}
                  pageSize={expandableTableAssignedChildServicesPageSize}
                  totalCount={expandableTableAssignedChildServicesTotalCount}
                  // stagedForUpdateChildServices={stagedForUpdateChildServices}
                  setAllProvidersOfChildService={setAllProvidersOfChildService}
                  fetchAssignedChildServicesByFilter={(filtersObj) => {}}
                  handleDeleteAssignedChildService={(service) => {}}
                />
              </div>
              <div style={{ height: "32px" }}></div>
            </div>
          </Modal>
        )}
      </div>
    );
  };

  const getServiceModesSection = () => {
    return (
      <ExpansionList>
        {serviceTypeData?.modes
          ?.filter((mode) => {
            if (props?.data?.mode == "assign" && !validModes.includes(mode)) {
              return false;
            } else if (
              props?.data?.mode == "update" &&
              !(
                assignServiceToPlanModesData?.[mode] ||
                validModes.includes(mode)
              )
            ) {
              return false;
            } else {
              return true;
            }
          })
          .map((row, index) =>
            assignServiceToPlanModesData?.[row] ||
            !(props?.data?.mode == "view") ? (
              <ExpansionPanel
                key={index}
                onExpandToggle={(expanded) => {
                  if (expanded && !expandableTables?.[row]) {
                    // fetching assigned service providers
                    if (props?.data?.editMode == "service-providers") {
                      fetchAssignedServiceProvidersByFilterHelper(
                        props?.data?.planId,
                        props?.data?.serviceId,
                        row,
                      );
                    }
                  }
                }}
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#CED4DA",
                  marginBottom: "20px",
                }}
                label={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      style={{ margin: 0, padding: 0 }}
                      checked={assignServiceToPlanModesData?.[row]?.isEnabled}
                      color="secondary"
                      disabled={props?.data?.mode == "view"}
                      onChange={(e) => {
                        updateAssignServiceToPlanModesDataField(
                          row.toString(),
                          "isEnabled",
                          e.target.checked,
                        );
                      }}
                    />
                    <div style={{ width: "10px" }}></div>
                    <div style={{ fontWeight: 700 }}>{row ? row : "None"}</div>
                  </div>
                }
                expandedSecondaryLabel={null}
                footer={null}
                headerStyle={{
                  margin: 0,
                  padding: 0,
                  marginLeft: 20,
                  marginRight: 20,
                  height: "40px",
                }}
                contentClassName="expansion-list-content-class-v2"
                // contentStyle={{ backgroundColor: "white", margin:0, padding:0, paddingBottom: "20px", paddingTop: "20px" }}
                children={
                  assignServiceToPlanModesData?.[row]?.isEnabled && (
                    <div>
                      <Row className="mp-row--modes-textfields-astp">
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Service MRP (Rs)`}
                              <label className="account-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <TextField
                                fullWidth
                                value={
                                  assignServiceToPlanModesData?.[row]
                                    ?.maxPrice ?? ""
                                }
                                onChange={(e) =>
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "maxPrice",
                                    stringToInt(e),
                                  )
                                }
                                disabled={props?.data?.mode == "view"}
                                type="number"
                                lineDirection="left"
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Discounted price (Rs)`}
                              <label className="account-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <TextField
                                fullWidth
                                value={
                                  assignServiceToPlanModesData?.[row]
                                    ?.discountedPrice ?? ""
                                }
                                onChange={(e) =>
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "discountedPrice",
                                    stringToInt(e),
                                  )
                                }
                                disabled={props?.data?.mode == "view"}
                                type="number"
                                lineDirection="left"
                              />
                            </div>
                          </div>
                        </Col>

                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Service status on plan`}
                              <label className="account-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <SelectField
                                menuItems={["Active", "Inactive"]}
                                fullWidth
                                onChange={(e) =>
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "isModeActive",
                                    e === "Active" ? true : false,
                                  )
                                }
                                disabled={props?.data?.mode == "view"}
                                value={
                                  assignServiceToPlanModesData?.[row]
                                    ?.isModeActive === true
                                    ? "Active"
                                    : assignServiceToPlanModesData?.[row]
                                          ?.isModeActive === false
                                      ? "Inactive"
                                      : ""
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-assign-service-isRecommendedForYou-div">
                            <Checkbox
                              style={{ margin: 0, padding: 0 }}
                              checked={
                                assignServiceToPlanModesData?.[row]
                                  ?.isRecommendedForYou ?? false
                              }
                              color="secondary"
                              disabled={props?.data?.mode == "view"}
                              onChange={(e) => {
                                updateAssignServiceToPlanModesDataField(
                                  row.toString(),
                                  "isRecommendedForYou",
                                  e.target.checked,
                                );
                              }}
                            />
                            <div style={{ width: "10px" }}></div>
                            <div className="mp-assign-service-apply-new-rule-label-div">
                              <div style={{ fontWeight: 500 }}>
                                {"Recommended for user"}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div
                        className="mp-assign-service-apply-new-rule-label-outer-div"
                        onClick={(e) => {
                          if (
                            assignServiceToPlanModesData?.[row]
                              ?.isAdvanceRuleApplicable ??
                            false
                          ) {
                            updateExtraAssignServiceToPlanModesDataField(
                              row?.toString(),
                              "expanded",
                              !(
                                extraAssignServiceToPlanModesData?.[row]
                                  ?.expanded ?? false
                              ),
                            );
                          } else {
                            updateExtraAssignServiceToPlanModesDataField(
                              row?.toString(),
                              "expanded",
                              false,
                            );
                          }
                        }}
                      >
                        <Checkbox
                          style={{ margin: 0, padding: 0 }}
                          checked={
                            assignServiceToPlanModesData?.[row]
                              ?.isAdvanceRuleApplicable ?? false
                          }
                          color="secondary"
                          disabled={props?.data?.mode == "view"}
                          onChange={(e) => {
                            updateAssignServiceToPlanModesDataField(
                              row.toString(),
                              "isAdvanceRuleApplicable",
                              e.target.checked,
                            );
                            updateExtraAssignServiceToPlanModesDataField(
                              row.toString(),
                              "expanded",
                              e.target.checked,
                            );
                            if (e.target.checked) {
                              updateAssignServiceToPlanModesDataField(
                                row.toString(),
                                "planServiceModeRules",
                                [EMPTY_PLAN_SERVCE_MODE_RULE],
                              );
                            } else {
                              updateAssignServiceToPlanModesDataField(
                                row.toString(),
                                "planServiceModeRules",
                                [],
                              );
                            }
                          }}
                        />
                        <div style={{ width: "10px" }}></div>
                        <div className="mp-assign-service-apply-new-rule-label-div">
                          <div style={{ fontWeight: 700 }}>
                            {"Apply sponsorship rules"}
                          </div>
                          <div className="mp-add-rule-btn-and-arrow-font-icon">
                            <Button
                              flat
                              // style={{ backgroundColor: "white", color: "#F97F0F" }}
                              disabled={
                                !(
                                  (
                                    assignServiceToPlanModesData?.[row]
                                      ?.planServiceModeRules ?? []
                                  )?.at(-1)?.relations?.length > 0
                                ) ||
                                props?.data?.mode == "view" ||
                                (assignServiceToPlanModesData?.[
                                  row
                                ]?.planServiceModeRules?.map(
                                  (objectt) => objectt.relations,
                                )?.[0]?.length ?? 0) >=
                                  (familyRelationsArr?.length ?? 0)
                              }
                              className={
                                "mp-plan-button-add-new-rule-enabled-astp"
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                updateAssignServiceToPlanModesDataField(
                                  row.toString(),
                                  "planServiceModeRules",
                                  [
                                    ...(assignServiceToPlanModesData?.[row]
                                      ?.planServiceModeRules ?? []),
                                    EMPTY_PLAN_SERVCE_MODE_RULE,
                                  ],
                                );
                              }}
                            >
                              +Add new rule
                            </Button>
                            <div style={{ width: "20px" }}></div>
                            {(extraAssignServiceToPlanModesData?.[row]
                              ?.expanded ?? false) ? (
                              <FontIcon>arrow_drop_up</FontIcon>
                            ) : (
                              <FontIcon>arrow_drop_down</FontIcon>
                            )}
                            <div style={{ width: "20px" }}></div>
                          </div>
                        </div>
                      </div>
                      {Boolean(
                        extraAssignServiceToPlanModesData?.[row]?.expanded ??
                        false,
                      ) &&
                        Boolean(
                          assignServiceToPlanModesData?.[row]
                            ?.planServiceModeRules,
                        ) && (
                          <div className="mp-row-modes-adv-rules-div-astp">
                            {assignServiceToPlanModesData?.[
                              row
                            ]?.planServiceModeRules?.map((e, idx) =>
                              getAdvanceRuleSection(
                                e,
                                (newRuleObj) => {
                                  if (
                                    assignServiceToPlanModesData?.[row]
                                      ?.planServiceModeRules?.[idx]
                                  ) {
                                    assignServiceToPlanModesData[
                                      row
                                    ].planServiceModeRules[idx] = newRuleObj;
                                    updateAssignServiceToPlanModesDataField(
                                      row.toString(),
                                      "planServiceModeRules",
                                      assignServiceToPlanModesData[row]
                                        .planServiceModeRules,
                                    );
                                  }
                                },
                                idx,
                                (indexToRemove) => {
                                  if (
                                    assignServiceToPlanModesData?.[row]
                                      ?.planServiceModeRules?.[indexToRemove]
                                  ) {
                                    const newArr = assignServiceToPlanModesData[
                                      row
                                    ].planServiceModeRules.filter(
                                      (_, index) => index !== indexToRemove,
                                    );
                                    updateAssignServiceToPlanModesDataField(
                                      row.toString(),
                                      "planServiceModeRules",
                                      newArr,
                                    );
                                  }
                                },
                                assignServiceToPlanModesData?.[
                                  row
                                ]?.planServiceModeRules?.map(
                                  (objectt) => objectt.relations,
                                ),
                                assignServiceToPlanModesData?.[row]
                                  ?.planServiceModeRules ?? [],
                                assignServiceToPlanModesData?.[row]
                                  ?.discountedPrice,
                              ),
                            )}

                            <div className="mp-plan-label">
                              <Checkbox
                                style={{ margin: 0, padding: 0 }}
                                checked={
                                  assignServiceToPlanModesData?.[row]
                                    ?.isSponsoredOnly ?? false
                                }
                                color="secondary"
                                disabled={props?.data?.mode == "view"}
                                onChange={(e) => {
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "isSponsoredOnly",
                                    e.target.checked,
                                  );
                                }}
                              />
                              {`Show this service only to users who are eligible to avail sponsored service`}
                            </div>
                          </div>
                        )}

                      {Boolean(
                        props?.data?.editMode == "service-providers",
                      ) && (
                        <>
                          <div className="mp-assigned-service-providers-label-outer-div">
                            <div style={{ width: "10px" }}></div>
                            <div className="mp-assign-service-apply-new-rule-label-div">
                              <div style={{ fontWeight: 700 }}>
                                {"Service providers assigned to the service"}
                              </div>
                            </div>
                          </div>
                          <div className="mp-astp-expandable-tables-outer-div">
                            {expandableTables?.[row]}
                          </div>
                        </>
                      )}
                    </div>
                  )
                }
              />
            ) : (
              <></>
            ),
          )}
      </ExpansionList>
    );
  };

  return (
    <div className="mp-plan-page-padding mp-astp-first-div">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="mp-plan-view">
            <div className="mp-plan-heading-with-back-button">
              <div
                className="mp-plan-back-btn"
                onClick={() => {
                  exitPage();
                }}
              >
                <FontIcon style={{ fontSize: "36px", marginTop: "2px" }}>
                  arrow_back
                </FontIcon>
              </div>
              <h1>{`Assign service to plan`}</h1>
            </div>
            <div className="mp-plan-buttons-container">
              <div className="mp-plan-buttons-right-alignment">
                {Boolean(props?.data?.mode != "view") && (
                  <Button
                    raised
                    disabled={
                      !(formData?.isContinueClicked ?? false) ||
                      props?.data?.mode == "view"
                    }
                    className={
                      !(formData?.isContinueClicked ?? false)
                        ? "mp-plan-button-save-disabled"
                        : "mp-plan-button-save-enabled"
                    }
                    onClick={() => {
                      if (isFormValid(formData, assignServiceToPlanModesData)) {
                        if (isServiceValidForConfirm()) {
                          assignServiceToPlan(
                            prepareBodyForServiceAssignment(),
                          );
                        }
                      }
                    }}
                  >
                    Save
                  </Button>
                )}

                <Button
                  raised
                  className="mp-plan-button-cancel"
                  onClick={() => {
                    exitPage();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      <div className="mp-plan-grey-heading">Plan details</div>
      <br />
      <div className="mp-plan-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Plan ID`}</div>
              <div>
                <TextField
                  value={props?.data?.planId ?? ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Plan name`}</div>
              <div>
                <TextField
                  value={planData?.basicDetails?.name ?? ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Account name`}</div>
              <div>
                <TextField
                  value={accountDetails?.accountName ?? ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ height: "25px" }}></div>

      <h3>Add new service</h3>

      <div className="mp-plan-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">
                {`Service type`}
                <label className="account-module-label-red"> *</label>
              </div>
              <div>
                <SelectField
                  placeholder="Select"
                  className="mp-plan-select-field"
                  menuItems={
                    serviceTypes
                      ? serviceTypes?.map((e) => ({
                          label: e?.name,
                          value: e?.id,
                        }))
                      : []
                  }
                  disabled={formData?.isContinueClicked ?? false}
                  value={formData?.service?.serviceTypeId ?? ""}
                  onChange={(e, idx) => {
                    setFormData((prev) => ({ ...prev, service: null }));
                    updateFormDataField("service", "serviceTypeId", e);
                    // setFormData((prev) => ({
                    //   ...prev,
                    //   serviceTypeIdNum: serviceTypes?.at(idx)?.id,
                    // }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">
                {`Service ID`}
                <label className="account-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  type="text"
                  value={formData?.service?.id ?? ""}
                  placeholder="Type and select"
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      service: {
                        serviceTypeId: formData?.service?.serviceTypeId,
                      },
                    }));
                    updateFormDataField("service", "id", e);
                  }}
                  disabled={
                    !formData?.service?.serviceTypeId ||
                    (formData?.isContinueClicked ?? false)
                  }
                  lineDirection="left"
                  inlineIndicator={
                    <Button
                      icon
                      className="text-fields__inline-btn"
                      disabled={
                        !formData?.service?.serviceTypeId ||
                        (formData?.isContinueClicked ?? false)
                      }
                      style={{
                        margin: "-10px",
                      }}
                    >
                      <FontIcon
                        style={{
                          color: "orange",
                          lineHeight: "0",
                          marginBottom: "15px",
                        }}
                        onClick={() => {
                          // check if this service provider is already assigned to this service And proceed
                          getServiceDataByFilter(
                            formData?.service?.id,
                            formData?.service?.serviceTypeId,
                            null,
                          );
                        }}
                      >
                        arrow_forward
                      </FontIcon>
                    </Button>
                  }
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div className="mp-astp-or-text">OR</div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">
                {`Service code`}
                <label className="account-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  type="text"
                  value={formData?.service?.name ?? ""}
                  placeholder="Type and select"
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      service: {
                        serviceTypeId: formData?.service?.serviceTypeId,
                      },
                    }));
                    updateFormDataField("service", "name", e);
                  }}
                  disabled={
                    !formData?.service?.serviceTypeId ||
                    (formData?.isContinueClicked ?? false)
                  }
                  lineDirection="left"
                  inlineIndicator={
                    <Button
                      icon
                      className="text-fields__inline-btn"
                      // disabled={!formData?.service?.serviceIdNum}
                      style={{
                        margin: "-10px",
                      }}
                      disabled={
                        !formData?.service?.serviceTypeId ||
                        (formData?.isContinueClicked ?? false)
                      }
                    >
                      <FontIcon
                        style={{
                          color: "orange",
                          lineHeight: "0",
                          marginBottom: "15px",
                        }}
                        onClick={() => {
                          // check if this service provider is already assigned to this service And proceed
                          getServiceDataByFilter(
                            null,
                            formData?.service?.serviceTypeId,
                            formData?.service?.name,
                          );
                        }}
                      >
                        arrow_forward
                      </FontIcon>
                    </Button>
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          {formData?.service?.serviceSubtypeId !== 0 && (
            <>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service sub type`}</div>
                  <div>
                    <TextField
                      value={formData?.service?.serviceSubtypeName ?? ""}
                      lineDirection="left"
                      disabled
                      placeholder="Sub type"
                    />
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
            </>
          )}
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Service name`}</div>
              <div>
                <TextField
                  value={formData?.service?.serviceName ?? ""}
                  lineDirection="left"
                  disabled
                  placeholder="Name"
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Button
            style={{
              marginLeft: "8px",
              marginTop: "18px",
              textTransform: "none",
            }}
            raised
            secondary
            disabled={
              (formData?.isContinueClicked ?? false) ||
              !formData?.service?.serviceName
            }
            onClick={() => {
              if (isServiceValidForConfirm()) {
                if (formData?.service?.serviceCategory === 1) {
                  // For a group service, only proceed once we've confirmed it has at least
                  // one active child service.
                  fetchAssignedChildServicesByFilter(
                    formData?.service?.id,
                    expandableTableAssignedChildServicesPageNum,
                    expandableTableAssignedChildServicesPageSize,
                    {},
                    true,
                    true,
                    true,
                  );
                } else {
                  setFormData((prev) => ({ ...prev, isContinueClicked: true }));
                  getServiceTypeDataById(formData?.service?.serviceTypeId);
                }
              }
            }}
          >
            {formData?.service?.serviceCategory === 1 ? "Confirm" : "Continue"}
          </Button>
        </Row>
      </div>
      <br />

      {(formData?.isContinueClicked ?? false) &&
        (formData?.service?.serviceCategory === 1
          ? getAssignedServicesSection()
          : getServiceModesSection())}
    </div>
  );
};

export default AssignServiceToPlan;
